import { IConfig } from './IConfig'
import { configLocal } from './config.local'
import { configDevelopment } from './config.development'
import { configStaging } from './config.staging'
import { configProduction } from './config.production'

let env = process.env.REACT_APP_ENV
let conf = configLocal

if (env === 'development') conf = configDevelopment
if (env === 'staging') conf = configStaging
if (env === 'production') conf = configProduction

export const config: IConfig = conf
